export const movementHeaders: string[] = [
    'Pedido', 'Matéria prima'/* , 'Tipo do movimento' */, 'Quantidade', 'Peso anterior',
    'Peso novo', 'Comp. anterior', 'Comp. novo', 'Status', 'Data',
]

export const movementFields: string[] = [
    'ploomesOrderId', 'rawMaterialName'/* , 'status' */, 'quantity', 'oldTotalWeight',
    'newTotalWeight', 'oldLengthInMm', 'newLengthInMm', 'status' , `createdAt`
]    
